import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import scrollToSection from './scrollToSection';
const { FiSearch } = FiIcons;

function SearchBar() {
  return (
    <section className="search-bar">
      <div className="search-bar-inner">
        <div className="search-field">
          <label>Location</label>
          <select defaultValue="">
            <option value="" disabled>Any location in Mumbai</option>
            <option>Bandra West</option>
            <option>Worli</option>
            <option>Juhu</option>
            <option>Powai</option>
            <option>Lower Parel</option>
            <option>Andheri West</option>
          </select>
        </div>
        <div className="search-field">
          <label>Property Type</label>
          <select defaultValue="">
            <option value="" disabled>All types</option>
            <option>Apartment</option>
            <option>Villa</option>
            <option>Penthouse</option>
            <option>Studio</option>
          </select>
        </div>
        <div className="search-field">
          <label>Budget</label>
          <select defaultValue="">
            <option value="" disabled>Any budget</option>
            <option>Under ₹2 Cr</option>
            <option>₹2 Cr – ₹5 Cr</option>
            <option>₹5 Cr – ₹10 Cr</option>
            <option>Above ₹10 Cr</option>
          </select>
        </div>
        <button className="search-btn" onClick={() => scrollToSection('listings')}>
          <SafeIcon icon={FiSearch} /> Search
        </button>
      </div>
    </section>
  );
}
export default SearchBar;
